<aside #mainSidebar class="main-sidebar sidebar-dark-primary elevation-4">
  <a [routerLink]="['/']" class="brand-link">
    <img
      src="/assets/images/logo.png"
      class="logo-img brand-image img-circle elevation-3"
      style="opacity: 0.8; height: 60px;"
    />
    <div class="brand-text font-weight-light small">
      <div>GAUSS</div>
      Foundation Platform
    </div>
  </a>
  <div class="sidebar">
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column nav-child-indent"
        data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-header">
          Information
        </li>
        <li class="nav-item"
          *ngFor="let menu of scope.menuItems['Information']">
          <a
            [routerLink]="[menu.path]"
            [ngClass]="styleClass(menu.path)"
            class="nav-link">
            <i class="nav-icon {{ menu.icon }}"></i>
            <p>
              {{ menu.name }}
            </p>
          </a>
        </li>
        <li class="nav-header" *ngIf="isMenu('AdminMenu')">
          Admin menu
        </li>
        <li class="nav-item" *ngFor="let menu of scope.menuItems['AdminMenu']">
          <a
            [routerLink]="[menu.path]"
            [ngClass]="styleClass(menu.path)"
            class="nav-link">
            <i class="nav-icon {{ menu.icon }}"></i>
            <p>
              {{ menu.name }}
            </p>
          </a>
        </li>
        <li class="nav-header" *ngIf="isMenu('DeveloperTools')">
          Developer Tools
        </li>

        <li class="nav-item" *ngFor="let menu of scope.menuItems['DeveloperTools']">
          <a
            [routerLink]="[menu.path]"
            [ngClass]="styleClass(menu.path)"
            class="nav-link">
            <i class="nav-icon {{ menu.icon }}"></i>
            <p>
              {{ menu.name }}
            </p>
          </a>

          <!-- <a href="{{menu.path}}" target="_blank"
            [ngClass]="styleClass(menu.path)"
            class="nav-link">
            <i class="nav-icon {{ menu.icon }}"></i>
            <p>
              {{ menu.name }}
            </p>
          </a> -->
        </li>
      </ul>
    </nav>
  </div>
</aside>
